import classNames from 'classnames';
import { useCallback, useContext } from 'react';
import { CreateReportModal } from '@/modules/common/components/modals/CreateReportModal.tsx';
import { InfoCard, ModalProviderContext } from 'ui';
import { FileDisabledIcon, LockIcon } from 'ui/icons';
import { ReportType } from 'api';

const options = [
  { label: 'Register Report', value: ReportType.RegisterList },
  { label: 'Issued Capital', value: ReportType.Capital },
  { label: 'Top Holders', value: ReportType.TopHolders },
  { label: 'Transaction Listing', value: ReportType.Transaction },
  { label: 'FATCA / CRS Status', value: null },
];

const CommonReports = () => {
  const { openModal } = useContext(ModalProviderContext);

  const handleOpenCreteReportModal = useCallback(
    (reportType: ReportType) => {
      // todo: change in case usage for investor
      openModal(CreateReportModal, { reportType });
    },
    [openModal],
  );
  return (
    <InfoCard title="Common Reports">
      <div className="space-y-2">
        {options.map(({ label, value }, index) => (
          <div
            key={`${value}_${index}`}
            onClick={value ? handleOpenCreteReportModal.bind(null, value) : undefined}
            className={classNames('flex gap-3 items-center border rounded-lg py-2.5 px-3', {
              'cursor-pointer': !!value,
              'hover:bg-gray-100': !!value,
            })}
          >
            <div className="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full">
              <img src={FileDisabledIcon} alt="file" />
            </div>
            <span className="text-sm">{label}</span>
            {!value && <img src={LockIcon} alt="blocked" className="ml-auto" />}
          </div>
        ))}
      </div>
    </InfoCard>
  );
};

export default CommonReports;
